module.exports = __webpack_public_path__ + "img/change_password_border.844c1eee.svg";